import React from 'react';
import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const images = [
    require('./../../images/gallery/portrait/pic4.jpg'),
    require('./../../images/gallery/portrait/pic5.jpg'),
    require('./../../images/gallery/portrait/pic6.jpg'),
    require('./../../images/gallery/portrait/pic7.jpg'),
    require('./../../images/gallery/portrait/pic1.jpg'),
]

var bnr1 = require('./../../images/background/line.png');

class About4 extends React.Component {

    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };

    render() {
        const options = {
            loop: true,
            autoplay: true,
            autoplayTimeout: 3000,
            margin: 30,
            nav: false,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            items: 1,
            dots: true
        };
        return (
            <>
                <div className="section-full p-t80 p-b80 bg-white inner-page-padding">
                    <div className="container">
                        <div className="section-content ">
                            <div className="row">
                                <div className="col-lg-5 col-md-5 ">
                                    <div className="m-about ">
                                        <OwlCarousel className="owl-carousel about-us-carousel" {...options}>
                                            {images.map((item, index) => (
                                                <div className="item" key={index}>
                                                    <div className="ow-img">
                                                        <NavLink to="/about"><img src={item} alt="" /></NavLink>
                                                    </div>
                                                </div>
                                            ))}

                                        </OwlCarousel>

                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-7">
                                    <div className="m-about-containt text-black p-t80"dir='RTL'>
                                        <div className="m-about-years bg-moving" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
                                            <span className="text-primary large-title">17</span>
                                            <span className="large-title-info" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'Bold' }}>سنة من الخبرة</span>
                                        </div>
                                        <h3 className="font-weight-600" style={{ fontFamily: 'Cairo, sans-serif', fontSize: '30px', fontWeight: 'Bold' }}>من نحن
                                        </h3>
                                        <p style={{ fontFamily: 'Cairo, sans-serif', fontSize: '14px', fontWeight: 'light' }}>
                                             .بناء الأسس للمقاولات تأسست في عام  2008 م  ومقرها الرئيسي في الأحساء
                                            .تقدم المؤسسة العديد من خدمات التشييد و البناء لجميع المشاريع السكنية والتجارية والحكومية
                                            .تهتم بناء الأسس للمقاولات كذلك بتقديم خدمات المقاولات العامة بكل احترافية و مصداقية مع جميع عملائها و موظفيها و أصحاب المصلحة
                                            .كما تلتزم بناء الأسس للمقاولات بإتقان جميع الأعمال التي تقوم بها من خلال الالتزام بتطبيق أعلى المعايير العالمية لتقديم خدمة ذات جودة عالية
                                        </p>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default About4;